import * as React from "react";
import "../../assets/scss/components/generic/toastMessage.scss";

export interface IToastMessageProps {
	message: React.ReactNode;
	color: "success" | "error" | "cancell";
}

const ToastMessage: React.FC<IToastMessageProps> = props => {
	return (
		// Accorning to toast message need to give classname "success","error","cancell"
		<div className={"toast_mes_wrap " + props.color}>
			<p className="message">{props.message}</p>
		</div>
	);
};

export default ToastMessage;
